import React, { useState, Fragment, useEffect } from "react";
import Select from "react-select";
import ReactSelect from "react-select";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import _ from "lodash";
import { noteOptions, NoteContentTypes } from "../../Constants/selections";
import AssignTokenContainer from "../AssignTokenContainer";
import ImageUpload from "../../components/ContentUpload/ImageUpload";
import PDFUpload from "../../components/ContentUpload/PDFUpload";
import VideoUpload from "../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../components/ContentUpload/YoutubeInput";
import MenuList from "../../components/ContentUpload/MenuList";
import SingleValue from "../../components/ContentUpload/SingleValue";
import AddressInput from "../AddressInput";
import UploadPanel from "./UploadPanel";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  PDF_UPLOAD,
} from "../../Constants/types";
import {
  UPLOADING_VIDEO,
  UPLOADING_IMAGE,
  UPLOADING_PDF,
} from "../../Constants/string";
import Firebase from "../../firebasehelper";
import "./index.css";

const emailIcon = require("../../assets/media/mail.png");

const AddNoteModal = ({
  brandData,
  roomId,
  uid,
  ticket,
  username,
  onChangeProfile,
  addTokens,
  isSuperSupport,
}) => {
  const [noteType, setNoteType] = useState("");
  const [noteText, setNote] = useState("");
  const [contentType, setContentType] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading_script, setLoadingScript] = useState("");
  const [uploads, setUploads] = useState([]);
  const [addressShowing, setAddressShowing] = useState(false);
  const [contactDivShowing, setContactDivShowing] = useState(false);
  const [contact, setContact] = useState("");
  const [isAddable, setIsAddable] = useState(false);
  const [address, setAddress] = useState("");
  const [tokenTasks, setTokenTasks] = useState([]);
  const [tokens, setTokens] = useState(null);
  useEffect(() => {
    if (brandData) {
      Firebase.getAllTokenEarnings((res) => {
        let tokenTasks = res.filter(
          (token) => token.brand === brandData.name || !token.brand
        );
        setTokenTasks(tokenTasks);
      });
    }
  }, [brandData]);
  useEffect(() => {
    if (contact || address) {
      setIsAddable(true);
    } else setIsAddable(false);
  }, [contact, address]);
  //handlers
  const handleChangeNoteType = (value) => {
    console.log("value", value);
    setNoteType(value);
    if (value.value === "delivery") {
      setAddressShowing(true);
    } else setAddressShowing(false);
    if (value.value === "contact") {
      setContactDivShowing(true);
    } else setContactDivShowing(false);
    if (value.value !== "delivery" && value.value !== "contact") {
      if (value.value && noteText) setIsAddable(true);
      else setIsAddable(false);
    }
  };
  const handleChangeNote = ({ target }) => {
    setNote(target.value);
    if (target.value && noteType.value) setIsAddable(true);
    else setIsAddable(false);
  };
  const handleSelectContentType = (value) => {
    setContentType(value);
  };
  const handleChangeContact = ({ target }) => {
    setContact(target.value);
  };
  const handleSetAddress = (value) => {
    setAddress(value);
  };
  const handleSetMediaURL = (mediaURL) => {
    const newUploads = _.cloneDeep(uploads);
    newUploads.push({
      media_type: contentType.value,
      media_url: mediaURL,
    });
    setUploads(newUploads);
  };
  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    setLoadingScript(loading_script);
  };
  const handleUploadError = (error) => {
    setLoadingScript("");
    setLoading(false);
  };
  const handleChangeTokens = (payload) => {
    setTokens(payload);
  };
  const uploadContent = (contentType) => async (mediaContent) => {
    const uploadFolder = "notes/" + brandData.name;
    const title = new Date().getTime().toString();
    if (contentType === PDF_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_PDF);
      let pdf_url = await Firebase.uploadPDF(
        mediaContent,
        title,
        uploadFolder + "/pdfs"
      );
      setLoading(false);
      handleSetMediaURL(pdf_url);
    } else if (contentType === IMAGE_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_IMAGE);
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      setLoading(false);
      handleSetMediaURL(img_url);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      setLoading(true);
      setLoadingScript(UPLOADING_VIDEO);
      uploadTask.on(
        "state_changed",
        handleUploadProgress,
        handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setLoading(false);
            setLoadingScript("");
            handleSetMediaURL(downloadURL);
          });
        }
      );
    } else if (contentType === YOUTUBE_URL) {
      handleSetMediaURL(mediaContent);
    }
  };

  const resets = () => {
    setNoteType("");
    setNote("");
    setAddressShowing(false);
    setContentType("");
    setUploads([]);
    setIsAddable(false);
    setTokens(null);
  };

  const addNote = async () => {
    let time = new Date().getTime().toString();
    let { note } = await Firebase.getTicketDataOnce(roomId, ticket.ticket_id);
    let notes = note ? note : [];
    notes.push({
      time: time,
      note: noteText,
      noteType: noteType.value,
      address: address,
      contact: contact,
      tokens: tokens,
      noter: username,
      noterId: uid,
      uploads: uploads,
    });
    if (contact) {
      onChangeProfile("email", contact, false);
    }
    if (address) {
      onChangeProfile("address", address, false);
    }
    if (tokens) {
      addTokens(tokens);
    }
    //add note
    addMessage(roomId, ticket.ticket_id, noteText);
    Firebase.updateTicketNote(roomId, ticket.ticket_id, notes);
    //refresh
    resets();
  };
  const addMessage = (selectedUserId, ticketId, note) => {
    const message = {
      type: "bot",
      message: note,
      username: username,
      time: new Date().getTime().toString(),
    };
    message.time = Date.now();
    Firebase.addMessage(selectedUserId, ticketId, message, (res) => {
      Firebase.setUnReadMessage(selectedUserId, ticketId, {
        latest: message.message,
        time: message.time,
        ticket: ticket,
      });
    });
  };
  const addNoteToAdminSupportChat = async () => {
    try {
      // Note: this function makes use of the selected ticket data passed down as prop
      const time = new Date().getTime().toString();
      let notes = ticket.notes ? ticket.notes : [];

      // append new note to notes array
      notes.push({
        time: time,
        note: noteText,
        noteType: noteType.value,
        noter: username,
        noterId: uid,
        uploads: uploads,
      });

      // show message in chat and attach note to ticket
      const { id, brand_id } = ticket;
      const message = {
        type: "bot",
        message: noteText,
        username: username,
        time: new Date().getTime().toString(),
      };
      Firebase.addMessageToAdminSupport(brand_id, id, message);
      Firebase.updateAdminTicketNotes(brand_id, id, notes);

      // reset state
      resets();
    } catch (err) {
      console.log("addNoteToAdminSupportChat() error", err);
    }
  };
  return (
    <div
      className="modal fade modal-container"
      id="add_note_dialog"
      tabIndex="1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add a note</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            className="modal-body pb-1"
            style={{ height: 570, fontSize: 12, overflowY: "auto" }}
          >
            <div className="form-group row">
              <div className="col-12">
                <p>Note Type</p>
                <Select
                  className="select"
                  classNamePrefix="note-select"
                  value={noteType}
                  onChange={handleChangeNoteType}
                  options={noteOptions}
                />
              </div>
            </div>
            {addressShowing && (
              <div className="form-group row">
                <div className="col-12">
                  <AddressInput onGetAddress={handleSetAddress} />
                </div>
              </div>
            )}
            {contactDivShowing && (
              <div className="form-group row">
                <div className="col-12">
                  <div className="email-container">
                    <img src={emailIcon} width="30px" alt="mail" />
                    <input
                      type="text"
                      className="form-control"
                      name="contact"
                      placeholder="Input the customer email..."
                      onChange={handleChangeContact}
                    />
                  </div>
                </div>
              </div>
            )}
            {noteType.value === "assign_tokens" && (
              <AssignTokenContainer
                tokenTasks={tokenTasks}
                territory={brandData.territory}
                onChange={handleChangeTokens}
                style={{ width: "94%" }}
              />
            )}
            <Fragment>
              <div className="form-group row">
                <div className="col-12">
                  <div className="row-div-space-between">
                    <p>Note</p>
                    <p>This note will be shared on the ticket</p>
                  </div>
                  <textarea
                    className="form-control form-control-md"
                    rows={5}
                    name="mynote"
                    style={{ width: "100%" }}
                    onChange={handleChangeNote}
                    value={noteText}
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-12">
                  <ReactSelect
                    value={contentType}
                    onChange={handleSelectContentType}
                    options={NoteContentTypes}
                    placeholder="Add a file to your note"
                    isSearchable={false}
                    components={{ MenuList, SingleValue }}
                  ></ReactSelect>
                </div>
              </div>
            </Fragment>

            {contentType && (
              <div className="input-container mb-2">
                {contentType.value === YOUTUBE_URL && (
                  <YoutubeInput onChangeContent={uploadContent(YOUTUBE_URL)} />
                )}
                {contentType.value === IMAGE_UPLOAD && (
                  <ImageUpload onChangeContent={uploadContent(IMAGE_UPLOAD)} />
                )}
                {contentType.value === PDF_UPLOAD && (
                  <PDFUpload onChangeContent={uploadContent(PDF_UPLOAD)} />
                )}
                {contentType.value === VIDEO_UPLOAD && (
                  <VideoUpload onChangeContent={uploadContent(VIDEO_UPLOAD)} />
                )}
              </div>
            )}
            <Fade
              in={loading}
              style={{
                transitionDelay: loading ? "800ms" : "0ms",
              }}
              unmountOnExit
            >
              <Fragment>
                <p>{loading_script}</p>
                <CircularProgress />
              </Fragment>
            </Fade>
            <UploadPanel contents={uploads} />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-green"
              data-dismiss="modal"
              disabled={!isAddable}
              onClick={isSuperSupport ? addNoteToAdminSupportChat : addNote}
            >
              Add note
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddNoteModal;



// WEBPACK FOOTER //
// ./src/components/AddNoteModal/index.js